import { Modal, Input, message } from "antd";
import { hasRole } from "./permissions";

export const isRoomUnavailable = (error: any): boolean =>
  error?.response?.data?.error === "room_unavailable" ||
  /already booked for the selected dates|conflicts with existing/i.test(
    String(error?.response?.data?.message || error?.message || "")
  );

export const getErrorMessage = (error: any): string =>
  error?.response?.data?.message || error?.message || "Request failed";

export const canForceOverlap = (): boolean => hasRole("admin", "manager");
export const promptForceReason = (action: string): Promise<string | null> =>
  new Promise((resolve) => {
    let reason = "";
    Modal.confirm({
      title: `Room unavailable — force ${action}?`,
      content: (
        <Input.TextArea
          rows={2}
          placeholder="Reason for forcing (min 5 characters)"
          onChange={(e) => {
            reason = e.target.value;
          }}
        />
      ),
      okText: "Force Override",
      okButtonProps: { danger: true },
      cancelText: "Cancel",
      onOk: () => {
        if (reason.trim().length < 5) {
          message.error("Reason must be at least 5 characters");
          return Promise.reject();
        }
        resolve(reason.trim());
        return Promise.resolve();
      },
      onCancel: () => {
        resolve(null);
      },
    });
  });
